module.exports = __webpack_public_path__ + "static/esc.8ef734a7e3f2cd10693be6ffd73aeff5.svg";